import api from 'http';
import { ArrowLeft } from 'lucide-react';
import AuthWrapper from 'NewComponents/Wrappers/AuthWrapper';
import Button from 'Pages/LoginPage/Button';
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import FloatingAuthInput from 'NewComponents/FormComponents/FloatingAuthInput/FloatingAuthInput';

const ForgotPasswordPage = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [state, setstate] = useState({
        emailValidation: false,
        emailSent: false,
    });

    const handleChange = (e) => {
        setEmail(e.target.value);
    };

    const handleReset = async () => {
        if (!email) {
            // toast.error('Please enter your email');
            setstate((prev) => ({ ...prev, emailValidation: true }));
            return;
        }
        setstate((prev) => ({ ...prev, emailValidation: false }));

        try {
            setLoading(true);
            await api.get(
                `${process.env.REACT_APP_TC_AUTH}/api/Account/SendPasswordResetLink/${email}`
            );
            setstate(prev => ({ ...prev, emailSent: true }))
            setError("");

            // if (response.ok) {
            // } else {
            //     const data = await response.json();
            //     toast.error(data.message || 'Failed to send reset link');
            // }
        } catch (error) {
            setError(error.response.data.responseMessage);
            // ErrorHandlingMessage(error)

        } finally {
            setLoading(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.charCode === 13) {
            handleReset();
        }
    };

    const navigateToLogin = () => {
        navigate("/login");
    };

    if (state.emailSent) {
        return (
            <AuthWrapper heading="Password Reset Link Sent" subheading="A password reset link has been sent to your email. Please check your inbox and follow the instructions to reset your password.">
                <div className="max-w-md mx-auto mt-10">
                    <div className="space-y-6">
                        <Button loading={loading} onClick={navigateToLogin} variant="primary" fullWidth disabled={loading}>
                            Back to Login
                        </Button>
                    </div>
                </div>

            </AuthWrapper>
        )
    }

    return (
        <AuthWrapper heading="Reset Password" subheading="Enter your email to receive a password reset link.">
            <div className="max-w-md mx-auto mt-10">
                <div className="space-y-6">
                    <div>
                        <FloatingAuthInput
                            id="email"
                            label="Email"
                            type="email"
                            placeholder="your@email.com"
                            required
                            name="email"
                            onChange={handleChange}
                            value={email}
                            autoFocus
                        />
                        {state.emailValidation && (
                            <div className="inline-block my-1 text-sm text-red-500"> Email is required.</div>
                        )}
                    </div>

                    <Button loading={loading} onClick={handleReset} variant="primary" fullWidth>
                        Send Reset Link
                    </Button>
                    {error ? <p className='font-semibold rounded-sm text-rose-400 '>{error}</p> : ""}
                    <button
                        type="button"
                        onClick={navigateToLogin}
                        className="flex items-center justify-center w-full text-sm font-medium text-gray-600 transition-colors hover:text-primary-600"
                    >
                        <ArrowLeft className="w-4 h-4 mr-1" />
                        Back to Login
                    </button>
                </div>
            </div>
        </AuthWrapper>
    )
}

export default ForgotPasswordPage
